import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import ModalCard from "./Modal";
import { getMessagingService } from "../../../store/actions/messaging";
import { getMessage } from "../../organisms/utils";
import { executeTaggeo } from "../../../store/actions";

class ModalMessaging extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOnClickModal = this.handleOnClickModal.bind(this);
  }

  componentDidMount() {
    const { currentFlux, currentCode, getMessagingService } = this.props;

    if (currentFlux) {
      getMessagingService(currentFlux, currentCode);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      currentFlux,
      currentCode,
      showModalMessaging,
      getMessagingService,
    } = this.props;

    const fluxChanged =
      prevProps.currentFlux !== currentFlux ||
      prevProps.currentCode !== currentCode;

    if (fluxChanged) {
      if (currentFlux !== "" && typeof currentFlux !== "undefined") {
        getMessagingService(currentFlux, currentCode);
      } else {
      }
    }

    if (prevProps.showModalMessaging !== showModalMessaging) {
    }
  }

  handleOnClickModal() {
    const { handleOnClickModal } = this.props;
    if (typeof handleOnClickModal === "function") {
      return handleOnClickModal();
    }
  }

  render() {
    const {
      showModalMessaging,
      currentCode,
      messages,
      isContainerTelcel,
      isLoading,
      variant
    } = this.props;

    let messageInformation = { data: {} };

    if (Array.isArray(messages) && messages.length > 0) {
      messageInformation = getMessage(messages, currentCode);
    }

    return (
      <div
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          zIndex: 999,
          width: "100%",
        }}
      >
        {/*  <ModalCardLoader isOpen={isLoading} /> */}
        <ModalCard
          variant={variant}
          isOpen={showModalMessaging && !isLoading}
          srcImage={
            messageInformation &&
            messageInformation.data &&
            messageInformation.data.icon
          }
          text={
            messageInformation &&
            messageInformation.data &&
            messageInformation.data.subject
          }
          textdetail={
            messageInformation &&
            messageInformation.data &&
            messageInformation.data.message
          }
          fontFamilyTextdetail="AMX-Regular"
          fontSizeDetail={isContainerTelcel ? "16px" : "16px"}
          colorTextdetail={isContainerTelcel ? "#757575" : "#232323"}
          marginTextDetail={isContainerTelcel ? "16px 0px 35px 0px" : undefined}
          buttontext="Entendido"
          widthButton={isContainerTelcel ? "95%" : undefined}
          fontFamilyButton="AMX-Bold"
          fontSizeButton={isContainerTelcel ? "16px" : "16px"}
          colorButton={isContainerTelcel ? "#ffffff" : undefined}
          backgroundColorButton={isContainerTelcel ? "#7B1FA2" : undefined}
          heightButton={isContainerTelcel ? "43px" : undefined}
          paddingButton={isContainerTelcel ? "2px 0px 0px 0px" : undefined}
          onclickModal={this.handleOnClickModal}
          fontSizeTitle={isContainerTelcel ? "20px" : "20px"}
          fontFamilyTitle="AMX-Bold"
          paddingCard={isContainerTelcel ? "16px 36px 50px 36px" : undefined}
          marginButton={isContainerTelcel ? "0px auto" : undefined}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { messagingReducer: { messages = [] } = {}, payments } = state;
  return {
    messages,
    isContainerTelcel: payments.isContainerTelcel,
    isLoading: state.messagingReducer.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMessagingService,
      executeTaggeo,
    },
    dispatch
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ModalMessaging)
);
